<template>
  <!-- 重設密碼-桌機彈窗 -->
  <div class="body-lock">
    <div v-if="$store.state.user.isResetPasswordActive" class="popup-wrap only-login-forget" :class="{ active: $store.state.user.isResetPasswordActive }">
      <div class="popup-box">
        <div class="form-popup">
          <div class="inner">
            <img class="logo" :src="brandLogo" alt @error="logoFailed = true">
            <h5>{{ $t("Bao.reset_password") }}</h5>
            <p>{{ $t("Bao.reset_password_desc") }}</p>
            <div class="verify-input" :class="{ 'form-input-error-1': errors.has('check_pass') }">
              <label>
                {{ $t("Bao.set_newPassword") }}
              </label>
              <input
                ref="newPassword"
                v-model="postForm.new_password"
                v-validate="'required'"
                class="modal_register_ipt bg-white border-0"
                :placeholder=" $t('Bao.password_notice')"
                type="password"
                name="check_pass"
                :data-vv-as="$t('Bao.newPassword')"
                autocomplete="new-password"
              >
              <div v-if="errors.has('check_pass')" class="help-block">
                {{ $t("Bao.new_password_error") }}
              </div>
            </div>
            <div class="verify-input" :class="{ 'form-input-error-1': errors.has('check_confirm_pass') }">
              <label>
                {{ $t("Bao.confirm_newPassword") }}
              </label>
              <input
                v-model="postForm.confirmPassword"
                v-validate="'required|confirmed:newPassword'"
                class="modal_register_ipt bg-white border-0"
                type="password"
                name="check_confirm_pass"
                :placeholder="$t('Bao.confirm_pass')"
                :data-vv-as="$t('Bao.confirmPassword')"
                autocomplete="off"
              >
              <div v-if="errors.has('check_confirm_pass')" class="help-block">
                {{ $t("Bao.password_not_match_error") }}
              </div>
              <p />
              <button
                class="button-style-7"
                type="button"
                @click="handleUpdate"
              >
                <span>{{ $t("Bao.send") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateCodInfo, forgotPassword } from '@/api/user'
import { setErrorMessage, showNotice, showRestrictedAccountError, getBrandLogo } from '@/utils/tool'

export default {
  name: 'ResetPassword',
  data() {
    const postForm = {
      new_password: null,
      confirmPassword: null,
      username: null,
      validate_code: null
    }
    return {
      postForm,
      logoFailed: false // logo 網址載不進來，改用內建 logo（見 getBrandLogo）
    }
  },
  computed: {
    brandLogo() {
      return getBrandLogo(this.logoFailed)
    }
  },
  created() {
    if (this.$route.params.validate_code != null) {
      this.postForm.validate_code = this.$route.params.validate_code
      this.postForm.username = this.$route.params.username
      validateCodInfo(this.postForm).then(response => {
        this.$store.commit('SET_RESET_PASSWORD_OPEN', true)
      }).catch(e => {
        this.$store.commit('SET_VAILTADA_FAIL', true)
        showNotice(this.$t('Bao.get_link_again'), this.goHome, true, false, true)
      })
    }
  },
  methods: {
    goHome() {
      this.$router.push('/')
    },
    handleUpdate() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          forgotPassword(this.postForm).then(response => {
            if (showRestrictedAccountError(response)) {
              return
            }
            showNotice(this.$t('Bao.reset_password_complete'), this.goHome, true, false, true)
          }).catch((error) => {
            if (!showRestrictedAccountError(error)) {
              showNotice(error.response.data.msg)
            }
          })
        } else {
          showNotice(this.$t('Bao.password_notice'), () => {}, true, false, true)
        }
      }).catch((error) => {
        setErrorMessage(error.response, this.errors)
      })
    }
  }
}
</script>
